import {
  Box,
  Button,
  Drawer,
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormControlLabel,
  Radio,
  RadioGroup,
  Divider,
  Tabs,
  Tab,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { rem, numberFormat } from "assets/js/common";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import moment from "moment";
import { schFormAction, loadPointAction } from "redux/reducers/point";
import Loading from "components/ui/loading";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  point: {
    "& .border-top": {
      borderTop: "1px solid #eee",
      padding: 0,
    },
    "& .divider-mg": {
      margin: `${rem(20)} 0 ${rem(14)}`,
    },
    "& .MuiButton-text": {
      lineHeight: rem(22),
    },
  },
}));

export default function point(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { schForm, loading, pointData } = useSelector((state) => state.point);

  const btnRef = useRef([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [clicked, setClicked] = useState(false);

  const [open, setOpen] = useState(false);
  const [val, setVal] = useState(0);
  const [pointList, setPointList] = useState([]);
  const [strtYmdList, setStrtYmdList] = useState([
    {
      label: "1개월",
      value: "30",
    },
    {
      label: "3개월",
      value: "90",
    },
    {
      label: "6개월",
      value: "180",
    },
  ]);

  const [pointTpList, setPointTpList] = useState([
    {
      label: "전체",
      value: "",
      className: "",
    },
    {
      label: "결제 적립",
      value: "0001",
      className: "save",
    },
    {
      label: "결제 사용",
      value: "0002",
      className: "",
    },
    {
      label: "적립 취소",
      value: "0003",
      className: "",
    },
    {
      label: "이벤트 적립",
      value: "0004",
      className: "save",
    },
    {
      label: "소멸",
      value: "0005",
      className: "",
    },
    {
      label: "제휴카드 추가",
      value: "0006",
      className: "save",
    },
    {
      label: "기타",
      value: "9999",
      className: "save",
    },
  ]);
  const [selectedItem, setSelectedItem] = useState("");
  const [tpValue, setTpValue] = useState("");

  window.appBackKeyHandle = () => {
    if (drawerOpen) {
      setDrawerOpen(false);
    } else {
      history.goBack();
    }
  };

  const handleChangeTab = (value, i) => {
    setSelectedItem("");
    if (value) {
      dispatch(
        loadPointAction({
          ...schForm,
          schStrtYmd: moment()
            .subtract(value, "days")
            .format("YYYYMMDD"),
          schEndYmd: moment().format("YYYYMMDD"),
        })
      );
    }
  };

  const getClass = (value, i) => {
    if (
      schForm.schStrtYmd ==
      moment()
        .subtract(value, "days")
        .format("YYYYMMDD")
    ) {
      return " select";
    } else {
      return "";
    }
  };

  const getTp = (value) => {
    let find = pointTpList.find((tp) => tp.value == value);
    return find ? find : "";
  };

  const handleChangeTp = (e) => {
    let value = e.target.value;
    setTpValue(e.target.value);
  };

  const tpSubmit = () => {
    setDrawerOpen(false);
    setSelectedItem(getTp(tpValue));

    let list = tpValue
      ? pointData.pointList.filter((point) => point.typeNo == tpValue)
      : pointData.pointList;
    console.log("list: ", list);
    setPointList(list);
  };

  // 2022.01.08~2022.02.08
  const getPeriod = `${moment(schForm.schStrtYmd).format(
    "YYYY.MM.DD"
  )} ~ ${moment(schForm.schEndYmd).format("YYYY.MM.DD")}`;

  const getTitle = (point) => {
    return point.storeCode == "2928"
      ? "제휴카드 추가"
      : point.mallFlag == "0"
      ? point.storeName
      : "메가마트몰";
  };
  const getSaleDate = (point) => {
    return moment(`${point.saleDate} ${point.saleTime}`).format(
      "YYYY.MM.DD HH:mm:SS"
    );
  };

  const getPointSign = (point) => {
    let result = "";
    if (point.useFlag == "1") {
      result = point.point > -1 ? "increase" : "decrease";
    } else if (point.useFlag == "2") {
      result = point.point < 0 ? "increase" : "decrease";
    }
    return result;
  };

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init) dispatch(loadAction({ back: true, title: "포인트", menu: true }));
  }, [init]);

  useEffect(() => {
    dispatch(
      loadPointAction({
        schStrtYmd: moment()
          .subtract("30", "days")
          .format("YYYYMMDD"),
        schEndYmd: moment().format("YYYYMMDD"),
      })
    );
  }, []);

  useEffect(() => {
    if (pointData.pointList && pointData.pointList.length > 0)
      setPointList(pointData.pointList);
  }, [pointData]);

  return (
    <>
      <Loading open={loading ? true : false} />
      <div className={"container nopad " + classes.point}>
        {pointData && (
          <>
            <div className="my-point bg-grey">
              <div className="point-card">
                <span className="tit">사용 가능한 포인트</span>
                <strong className="save-point">
                  {pointData.point.toLocaleString()}P
                </strong>
                <Divider className="divider-mg" />

                <div className="extinct-point">
                  <span className="date">
                    당월 소멸 예정(
                    {pointData.exYmd
                      ? moment(pointData.exYmd).format("YYYY.MM.DD")
                      : ""}
                    )
                  </span>
                  <span className="point-num">
                    {pointData.exPoint > -1 ? "" : "-"}
                    {pointData.exPoint.toString()}P
                  </span>
                </div>
              </div>
            </div>
            <div className="point-info">
              <h2>포인트 내역</h2>
              <div className="point-period">
                {strtYmdList.map((ymd, i) => (
                  <Button
                    key={ymd.value}
                    fullWidth
                    className={"btn-rounded" + getClass(ymd.value, i)}
                    size="small"
                    onClick={() => handleChangeTab(ymd.value, i)}
                  >
                    {ymd.label}
                  </Button>
                ))}
              </div>
              <div className="type-select">
                <Box display="flex" justifyContent="space-between">
                  <Button
                    onClick={() => {
                      setDrawerOpen(true);
                    }}
                    className="fontN"
                  >
                    {selectedItem.label || "전체"}
                    <i className="ico-filter" />
                  </Button>
                  <div className="srch-period">
                    <b>기간</b>
                    <span>{getPeriod}</span>
                  </div>
                </Box>
              </div>
              <div className="point-list">
                {pointList.length == 0 ? (
                  <div className="nodata" style={{ padding: "130px 0 100px" }}>
                    <Box className="illust">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/icon/nodata.svg`}
                      />
                    </Box>
                    <p className="color-info">조회된 내역이 없습니다</p>
                  </div>
                ) : (
                  <ul>
                    {pointList.map((point, i) => (
                      <li key={i}>
                        <dl className="check-point">
                          <dt>{getTitle(point)}</dt>
                          <dd>{getSaleDate(point)}</dd>
                        </dl>
                        <span className="used-point">
                          <b className={getPointSign(point)}>
                            {numberFormat(Math.abs(point.point))}P
                          </b>
                          {getTp(point.typeNo).label}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </>
        )}
        <Box className="notice is-bottom border-top">
          <p className="title">
            <i className="ico-noti" />
            포인트 적립 · 사용 안내
          </p>
          <ul className="list list-dot color-info font-14">
            <li>포인트는 10점 단위로 사용 가능합니다.</li>
            <li>
              최종 적립일로부터 2년간 포인트 적립 실적이 없는 경우 소멸되거나
              사용이 제한될 수 있습니다.
            </li>
            <li>반품, 교환, 환불시에는 해당 포인트가 자동으로 차감됩니다.</li>
          </ul>
        </Box>

        {/* ST : tp */}
        <Drawer
          anchor="bottom"
          open={drawerOpen}
          onClose={() => {
            setDrawerOpen(false);
          }}
          className="drawer-common-bottom size-high point-type"
        >
          <div className="drawer-head">
            <h3>포인트 유형 선택</h3>
            <IconButton
              aria-label="close"
              className="btn-close"
              onClick={() => {
                setDrawerOpen(false);
                setSelectedItem("");
                setTpValue("");
              }}
            >
              <span className="hidden">닫기</span>
            </IconButton>
          </div>

          <div className="drawer-body">
            <Box className="box-type-1">
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                defaultValue={tpValue || ""}
                value={tpValue || ""}
                onChange={handleChangeTp}
              >
                {pointTpList.map((tp) => (
                  <FormControlLabel
                    key={tp.value}
                    value={tp.value}
                    control={
                      <Radio
                        color="primary"
                        icon={<span className="radio-icon" />}
                        checkedIcon={<span className="radio-icon-checked" />}
                        className="mgR15"
                      />
                    }
                    label={tp.label}
                  />
                ))}
              </RadioGroup>
            </Box>
          </div>
          <div className="drawer-foot">
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                tpSubmit();
              }}
            >
              선택완료
            </Button>
          </div>
        </Drawer>
        {/* EN : tp */}
      </div>
    </>
  );
}
